import Vue from 'vue';
import Router from 'vue-router';
import RummyHome from '@/components/home/rummy_home';
import AnalystManager from "../utils/analyst";
import { reloadLanguageAsync } from '../utils/i18n'
import store from '../store'
Vue.use(Router);

const myRouter = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: RummyHome
    },
    {
      path: '/withdraw2',
      name: 'withdraw',
      components: {
        "default": resolve => require(["../components/withdraw/rummy-withdraw.vue"], resolve)
      }
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      components: {
        "default": resolve => require(["../components/withdraw/withdraw.vue"], resolve)
      }
    },
    {
      path: '/deposit',
      name: 'Deposit',
      components: {
        "default": resolve => require(["../components/deposit/rummy-deposit.vue"], resolve)
      }
    },
    {
      path: '/deposit/record',
      name: 'Deposit Record',
      components: {
        "default": resolve => require(["../components/record/deposit-record.vue"], resolve)
      }
    },
    {
      path: '/withdraw/record',
      name: 'Withdraw Record',
      components: {
        "default": resolve => require(["../components/record/withdraw-record.vue"], resolve)
      }
    },
    {
      path: '/bet/record',
      name: 'Bet Record',
      components: {
        "default": resolve => require(["../components/record/bet-record.vue"], resolve)
      }
    },
    {
      path: '/TC',
      name: 'TC',
      components: {
        "default": resolve => require(["../components/user/T&C.vue"], resolve)
      }
    },
    {
      path: '/refund/policy',
      name: 'refund policy',
      components: {
        "default": resolve => require(["../components/user/refund_policy.vue"], resolve)
      }
    },
    {
      path: '/privacy/policy',
      name: 'privacy policy',
      components: {
        "default": resolve => require(["../components/user/privacy_policy.vue"], resolve)
      }
    },
  ]
});

myRouter.beforeEach(async (to, from, next) => {
  window.vueLastPath = from.path;
  //加载语言包
  reloadLanguageAsync();
  //异步上报
  let hander = setTimeout(() => {
      if (hander) clearTimeout(hander);
      hander = null;
      let cn = store.getters["common/getChannel"];
      AnalystManager.browse(to , cn);
  }, 50);
  //下一步
  next();
});
export default myRouter;


// WEBPACK FOOTER //
// ./src/router/index.js